/* eslint-disable @typescript-eslint/no-explicit-any */
import { Actions } from 'gatsby';
import { ReactNode } from 'react';

export type pageTypes = 'home' | 'category' | 'author' | 'single';
export type singlePageTypes = 'calculators' | 'score-guide';
export type allPageTypes = pageTypes | singlePageTypes;

export interface IGatsbyActionsGraphQL {
  actions: Actions;
  graphql: any;
  reporter?: any;
  cache?: any;
}
export interface ICard {
  icon: string;
  spotIcon: string;
  heading: string;
  description: string;
  link: string;
}
export interface ICategoryAncestor {
  name: string;
  uri: string;
  databaseId: number;
  slug: string;
}
export interface ICategory {
  name: string;
  slug?: string;
  uri: string;
  databaseId?: number;
  ancestors?: {
    nodes: ICategoryAncestor[];
  };
}
export interface ISEO {
  title: string;
  description: string;
  metaRobotsNoindex: string;
  metaRobotsNofollow: string;
  og: {
    description: string;
    image: string;
    title: string;
    type: string;
    updated_time: string;
    url: string;
  };
  twitter: {
    card: string;
    description: string;
    image: string;
    site: string;
    title: string;
  };
  schema: string;
}
export interface IAuthor {
  name?: string;
  firstName?: string;
  lastName?: string;
  slug?: string;
  uri: string;
  url?: string;
  databaseId: number;
  description?: string;
  expSeo?: ISEO;
  popularPosts?: IPost[];
  featuredPosts?: IPost[];
  latestPosts?: {
    posts: {
      nodes: IPost[];
    };
  };
}

export enum ExpCustomFields {
  QA = 'exp-quickanswer',
  CustomPermLink = 'custom_permalink',
  PostViews = 'wpb_post_views_count',
  AdobeVisit = 'adobe_visit_data',
  CtaQuinn = 'cta_quinn',
  CtaSavings = 'cta_savingsgroup',
  CtaSuperMoney = 'cta_supermoney',
  ImgHeader = 'img_header',
  ScoreNum = 'score_num',
  HrefLanf = 'hreflang',
  CTACustom = 'cta_custom',
  Calculator = 'calculator-mini',
  DateHide = 'date_hide',
  Editor = 'byline-editor'
}
export interface IExpCustomFields {
  key: ExpCustomFields;
  value: string;
}

export interface IContentGroup {
  title: string;
  content: ReactNode | string;
  id: string;
}
export interface IPost {
  databaseId: number;
  link: string;
  featuredImage?: {
    node: any;
  };
  slug?: string;
  uri?: string;
  content?: string;
  modifiedContent?: string;
  title: string;
  excerpt: string;
  date: string;
  author?: {
    node: IAuthor;
  };
  readtime?: string | number;
  categories: {
    nodes: ICategory[];
  };
  expCustomFields?: IExpCustomFields[];
  readTime?: number;
  expPostContent?: {
    featImg: {
      src: string;
      srcset: string;
      alt: string;
      sizes: string;
      position: 'top' | 'bottom' | 'middle';
      srcWebP: string;
      srcsetWebP: string;
    };
  };
  expSeo?: ISEO;
  template?: {
    templateName: string;
  };
  authorDatabaseId?: number;
  expLooker?: string[];
}

export type page = 'all' | 'home' | 'category' | 'author';
// Customizer settings
export interface ILatestPostsCustomizerSettings {
  label: string;
  page: page;
}

export type themes = 'white' | 'coconut' | 'dark';
export type backgroundType = 'textured' | 'solid';
export interface ICustomizerSettings {
  component?: string;
  preview?: boolean;
  data?: any;
  settings?: any;
}
export type IEducationalAccordion = IContentGroup & {
  lead?: string;
};
export type QSWidgetClassNames = 'qs-widget-background' | 'qs-widget-no-background';
export type SGWidgetTypes = 'purchase' | 'refinance' | 'leaseBuyout';
export type SMWidgetTypes = 'mortgage' | 'mortgagerefi' | 'heloc' | 'heloan';
export type QSWidgetTypes =
  | 'highyield'
  | 'mma'
  | 'cd'
  | 'investing'
  | 'checking'
  | 'business_checking'
  | 'annuity'
  | 'auto_insurance'
  | 'home_insurance'
  | 'life_insurance'
  | 'pet_insurance'
  | 'rental_insurance';
export type CalculatorTypes =
  | 'apr-inc'
  | 'creditcard-multi-inc'
  | 'mortgage-inc'
  | 'personal-loan-inc'
  | 'car-payment-inc'
  | 'reverse-car'
  | 'savings-inc';

export interface PostContentParams {
  categoryId?: number;
  postId?: number;
  qsWidget?: QSWidgetTypes;
  sgWidget?: SGWidgetTypes;
  smWidget?: SMWidgetTypes;
  catSlug?: string;
  isSEMtemplate?: boolean;
  calculator?: CalculatorTypes | null;
  isFullCalculator?: boolean;
  lookerData?: {
    token: string;
    value: string;
  }[];
}
